// extracted by mini-css-extract-plugin
export default {"page":"byte_page__RHq6D"};